import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="system-settings--form"
// Auto-fills active_from and active_until based on year and start_month
export default class extends Controller {
  static targets = ["year", "startMonth", "activeFrom", "activeUntil"]

  connect() {
    this.updateDates()
  }

  updateDates() {
    const year = parseInt(this.yearTarget.value, 10)
    const month = parseInt(this.startMonthTarget.value, 10)

    if (!year || !month || month < 1 || month > 12) return

    // active_from = first day of start_month in the given year
    const activeFrom = `${year}-${String(month).padStart(2, "0")}-01`

    // active_until = last day of (start_month - 1) in the next year (i.e. 1 year period)
    // e.g. year=2027, start_month=9 → active_from=2027-09-01, active_until=2028-08-31
    let untilYear = year + 1
    let untilMonth = month - 1
    if (untilMonth < 1) {
      untilMonth = 12
      untilYear = year
    }
    // Last day of untilMonth: create date for 1st of next month, subtract 1 day
    const lastDay = new Date(untilYear, untilMonth, 0).getDate()
    const activeUntil = `${untilYear}-${String(untilMonth).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`

    this.activeFromTarget.value = activeFrom
    this.activeUntilTarget.value = activeUntil
  }
}
